module.exports = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n  <div class=\"modal-dialog portlet modal-xxlarge\" uib-modal-transclude></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/windowTemplateNotificationXXLarge.tpl.html
// module id = 940
// module chunks = 12